import React, { useState } from 'react';

import { Agreement } from '../../../../../../../api-client/models/documents/Agreement';
import documentIcon from '../../../../../../../assets/images/svg/document.svg';
import { Button, Image, Loader } from '../../../../../../../components';
import FileSize from '../../../../../../../components/common/utils/FileSize/FileSize';
import apiClientConfig from '../../../../../../../configs/app';
import { createAgreementProvider } from '../../../../../../../di';
import { formatDate } from '../../../../../../../formatters';
import { useErrorCallback } from '../../../../../../../hooks';
import { downloadPDF } from '../../../../../../../utils/downloadPDF';
import styles from '../DocumentsToProjectsItem.module.scss';

interface Props {
  document: Agreement;
}

export const AgentDocumentAgreement = ({ document }: Props) => {
  const [activeDownload, setActiveDownload] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleError = useErrorCallback();

  const downloadZIP = async (url: string) => {
    setLoading(true);
    try {
      const provider = await createAgreementProvider();
      const result = await provider.exportZip(url);
      window.open(apiClientConfig.apiBaseUrl + result.url, '_blank');
    } catch (error) {
      if (error instanceof Error) {
        await handleError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ul key={document.uuid} className={styles.documentsToProjectBody__list}>
      <li className={styles.documentsToProjectBody__item}>
        <Image className={styles.documentsToProjectBody__icon} src={documentIcon} />
        <a
          href={document.digitalSign ? `${document.file.url}/signed-document` : document.file.url}
          target="_blank"
          rel="noreferrer"
          className={styles.documentsToProjectBody__title}
        >
          Подтверждение присоединения к агентскому договору
        </a>
        <a
          href={document.digitalSign ? `${document.file.url}/signed-document` : document.file.url}
          target="_blank"
          rel="noreferrer"
          className={styles.documentsToProjectBody__size}
        >
          pdf, <FileSize file={document.file} />
        </a>
        <a
          className={styles.documentsToProjectBody__watch}
          href={document.digitalSign ? `${document.file.url}/signed-document` : document.file.url}
          target="_blank"
          rel="noreferrer"
        >
          Нажмите, чтобы посмотреть
        </a>
        <a
          href={document.digitalSign ? `${document.file.url}/signed-document` : document.file.url}
          target="_blank"
          rel="noreferrer"
          className={styles.documentsToProjectBody__date}
        >
          {formatDate(document.createdAt)}
        </a>
        <a
          href={document.digitalSign ? `${document.file.url}/signed-document` : document.file.url}
          target="_blank"
          rel="noreferrer"
          className={styles.documentsToProjectBody__dateText}
        >
          дата подписания
        </a>

        <div className={styles.documentsToProjectBody__makeReport}>
          <Button
            className={styles.documentsToProjectBody__buttonSave}
            onClick={() => setActiveDownload((prevState) => !prevState)}
          >
            <div />
            скачать
          </Button>

          {activeDownload && (
            <div className={styles.documentsToProjectBody__download}>
              <Button
                className={styles.documentsToProjectBody__buttonDownload}
                onClick={() =>
                  downloadPDF(
                    `${document.file.url}/signed-document`,
                    document.file.name,
                    handleError
                  )
                }
              >
                <div />
                скачать PDF
              </Button>
              <Button
                className={styles.documentsToProjectBody__buttonDownload}
                onClick={() => downloadZIP(document.file.url)}
              >
                <div />
                скачать ZIP
              </Button>
              {loading && <Loader />}
            </div>
          )}
        </div>
      </li>
    </ul>
  );
};
